import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    citiesList: [],
    tripsList: [],
    seatsList: [],
    createdCart: null, // Store created cart
    fetchedCart: null,  // Store fetched cart
    updatedCart: null,
    seatReservationList : [],
    /**
     * The OUTBOUND trip.
     *
     * A round trip has two, and both used to be written here -- picking the
     * return overwrote the outbound, so every screen downstream read the
     * return's journey no matter which half it was describing.
     */
    trip: {},
    /** The RETURN trip, kept apart from the outbound for that reason. */
    returnTrip: {},

};

const BusBookingSlice = createSlice({
    name: "BusBookingSlice",
    initialState,
    reducers: {
        setCitiesList(state, action) {
            state.citiesList = action.payload;
        },
        setTripsList(state, action) {
            state.tripsList = action.payload;
        },
        setSeatsList(state, action) {
            state.seatsList = action.payload;
        },
        setCreatedCart(state, action) {
            state.createdCart = action.payload;
        },
        setFetchedCart(state, action) {
            state.fetchedCart = action.payload;
        },
        setUpdatedCart(state, action) {
          state.updatedCart = action.payload;
        },
        clearCartData(state) {
            state.createdCart = null;
            state.fetchedCart = null;
        },
        addSeatReservationList(state, action) {
          state.fetchedCart = action.payload;
      },
      setTrip(state,action){
        state.trip = action.payload;
      },
      setReturnTrip(state,action){
        state.returnTrip = action.payload;
      }
    }
});

export const { 
    setCitiesList, 
    setTripsList, 
    setSeatsList, 
    setCreatedCart, 
    setFetchedCart, 
    setUpdatedCart, 
    clearCartData,
    addSeatReservationList,
    setTrip,
    setReturnTrip
} = BusBookingSlice.actions;

export default BusBookingSlice;
